import React from 'react';
import { useSelector } from 'react-redux';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { getBadge } from 'selectors';
import { faMessage } from '@fortawesome/pro-regular-svg-icons';
import { NavLink } from '../components';

export const MessagesLink = (props) => {
  const badge = useSelector(getBadge('navbar.messages'));
  return (
    <NavLink
      {...props}
      icon={faMessage}
      textPath="navbar.messages"
      url={urlConstructor(urlMap.MESSAGES)}
      displayPath="/messages?all=true"
      badge={badge}
      name="messages"
    />
  );
};
